import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, FieldLabel, FlexBox, } from '@dixa/lib-shared-habla';
import { useHookForm } from 'utils/hookForm';
/** Represents the React Hook Form variant of the {@link Checkbox} component. */
export const HookFormCheckbox = (props) => {
    var _a;
    const { controller: { field }, controllerProps: { name: id }, } = useHookForm(props);
    return (_jsxs(FlexBox, Object.assign({ gap: "200", alignItems: "center", className: props.className }, { children: [_jsx(Checkbox, Object.assign({}, field, { id: id, checked: field.value, disabled: (_a = props.componentProps) === null || _a === void 0 ? void 0 : _a.disabled })), props.label && (_jsx(FieldLabel, Object.assign({ htmlFor: id, helpIcon: props.helpIcon }, { children: props.label })))] })));
};
